import React from 'react';
import { LocaleLabels, SUPPORTED_LOCALES } from '@packages/global';
import type { LanguageSwitcherProps } from './types';

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  compact = false,
  locale,
  onLocaleChange,
  compactTitle,
  compactClassName = 'w-full flex items-center justify-center p-2 rounded-lg text-gray-400 hover:text-gray-50 hover:bg-bg-elevated transition-all duration-200 cursor-pointer',
  containerClassName = 'flex items-center gap-1 p-1 rounded-lg bg-bg-elevated',
  activeClassName = 'bg-bg-surface text-gray-50 shadow-sm',
  inactiveClassName = 'text-gray-400 hover:text-gray-200',
}) => {
  if (compact) {
    const currentIndex = SUPPORTED_LOCALES.indexOf(locale);
    const nextLocale = SUPPORTED_LOCALES[(currentIndex + 1) % SUPPORTED_LOCALES.length];
    const currentLabel = LocaleLabels[locale];

    return (
      <button
        onClick={() => onLocaleChange(nextLocale)}
        title={compactTitle ? compactTitle(currentLabel.full) : `当前：${currentLabel.full}，点击切换`}
        className={compactClassName}
      >
        <span className="text-xs font-semibold">{currentLabel.short}</span>
      </button>
    );
  }

  return (
    <div className={containerClassName}>
      {SUPPORTED_LOCALES.map((nextLocale) => (
        <button
          key={nextLocale}
          onClick={() => onLocaleChange(nextLocale)}
          title={LocaleLabels[nextLocale].full}
          className={`flex-1 flex items-center justify-center px-2 py-1.5 rounded-md text-xs font-medium transition-colors duration-200 cursor-pointer ${locale === nextLocale ? activeClassName : inactiveClassName}`}
        >
          {LocaleLabels[nextLocale].full}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
